import videojs from 'video.js';

// Get the Component base class from Video.js
const Button = videojs.getComponent('Button');

let toggleSource_moveTo = async (inst, curTime) => {
  if (!ToggleSource.movedDone) {
    if (inst.player().currentTime() < curTime) {
      inst.player().currentTime(curTime);
      return inst.player().currentTime();
    }
  }
}

let toggleSource_moveAndPlay = async (inst, curTime, paused) => {
  inst.player().play();
  inst.player().on('loadedmetadata', function(){
    toggleSource_moveTo(inst, curTime).then(newTime => {
      if (newTime >= curTime) {
        ToggleSource.movedDone = true;
        // clean up listeners
        inst.player().off('loadedmetadata');
        return;
      }
    });
  });
  inst.player().on('canplaythrough', function(){
    toggleSource_moveTo(inst, curTime).then(newTime => {
      if (newTime >= curTime) {
        ToggleSource.movedDone = true;
        ToggleSource.movingTimer = false;
        // clean up listeners
        inst.player().off('loadedmetadata');
        inst.player().off('canplaythrough');
        return;
      }
    });
  });
};

// The videojs.extend function is used to assist with inheritance. In
// an ES6 environment, `class TitleBar extends Component` would work
// identically.
var ToggleSource = videojs.extend(Button, {

  // The constructor of a component receives two arguments: the
  // player it will be associated with and an object of options.
  constructor: function(player, options) {

    // It is important to invoke the superclass before anything else, 
    // to get all the features of components out of the box!
    Button.call(this, player, options);

    this.addClass('vjs-button-toggle-source');
    this.addClass('vjs-icon-circle');

    this.backCamera = null;
    this.frontCamera = null;

    this.player().ready(() => {
      if (this.frontCamera === null) {
        this.preloadSources();
        if (this.player().currentSources().length > 1) {
          this.frontCamera = this.player().currentSource();
          this.backCamera = this.player().currentSources()[1];
        }else{
          this.disable();
        }
      }
    });
  },

  preloadSources() {
    /**
     * Start preloading shadow video
     */
    for (let i=0; i < this.player().currentSources().length; i++) {
      if (this.player().currentSources()[i]) {
        var preloadLink = document.createElement('link');
        preloadLink.href = this.player().currentSources()[i].src;
        preloadLink.rel = "preload";
        preloadLink.as = "video";
        preloadLink.type = this.player().currentSources()[i].type;
        document.head.appendChild(preloadLink);
      }
    }
  },

  createEl(tag, props = {}, attributes = {}) {
    const el = Button.prototype.createEl.call(this, tag, props, attributes);
    el['innerHTML'] = '<span aria-hidden="true" class="vjs-icon-placeholder">Ángulo</span>';

    this.createControlTextEl(el);

    return el;
  },

  handleClick(event) {
    ToggleSource.movedDone = false;
    const curTime = this.player().currentTime();
    const paused = this.player().paused();
    if (this.player().currentSource().src === this.backCamera.src) {
      this.removeClass('back-view');
      this.player().src(this.frontCamera);
      this.player().ready(function() {
        toggleSource_moveAndPlay(this, curTime, paused);
      });
      this.controlText('Cámara Trasera');
    }else{
      this.addClass('back-view');
      this.player().src(this.backCamera);
      this.player().ready(function() {
        toggleSource_moveAndPlay(this, curTime, paused);
      });
      this.controlText('Cámara Frontal');
    }
  },

});

ToggleSource.movedDone = true;
ToggleSource.movingTimer = false;
ToggleSource.prototype.controlText_ = 'Cámara Trasera';

// Register the component with Video.js, so it can be used in players.
videojs.registerComponent('ToggleSource', ToggleSource);

export default ToggleSource;
